import React from "react";

import {
    createApiFactory,
    discoveryApiRef,
    fetchApiRef,
} from "@backstage/core-plugin-api";
import {
    ApiBlueprint,
    createFrontendPlugin,
    PageBlueprint,
} from "@backstage/frontend-plugin-api";

import {
    K8sDashboardApiRef,
    K8sDashboardClient,
    kubernetesApiRef,
} from "./apis";
import { pluginId, rootRouteRef } from "./routes";

const K8sDashboardPageExt = PageBlueprint.make({
    params: {
        path: "/k8s-dashboard",
        routeRef: rootRouteRef,
        title: "K8s Dashboard",
        loader: async () => {
            const m = await import("./components/K8sDashboardPage");
            return React.createElement(m.K8sDashboardPage);
        },
    },
});

const k8sDashboardApiExt = ApiBlueprint.make({
    name: pluginId,
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: K8sDashboardApiRef,
                deps: {
                    kubernetesApi: kubernetesApiRef,
                    discoveryApi: discoveryApiRef,
                    fetchApi: fetchApiRef,
                },
                factory: ({ kubernetesApi, discoveryApi, fetchApi }) =>
                    new K8sDashboardClient(
                        kubernetesApi,
                        discoveryApi,
                        fetchApi
                    ),
            })
        ),
});

const k8sDashboardPlugin = createFrontendPlugin({
    pluginId,
    extensions: [K8sDashboardPageExt, k8sDashboardApiExt],
});

export default k8sDashboardPlugin;
